import { render, staticRenderFns } from "./ProductsFilter.vue?vue&type=template&id=be19b576&scoped=true&"
import script from "./ProductsFilter.vue?vue&type=script&lang=js&"
export * from "./ProductsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFilter.vue?vue&type=style&index=0&id=be19b576&scoped=true&lang=css&"
import style1 from "./ProductsFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be19b576",
  null
  
)

export default component.exports